import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-pause\"><path d=\"M6 5h5v15H6zm8 0h5v15h-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol